import React, {useEffect, useState} from "react";

const VoterRoutedForm = ({element, onSubmit, onCancel, onDeleteElement}) => {
    const [formData, setFormData] = useState({paths:[], connectors:[], attribs:{}, ...element});

    useEffect(() => {
        if (!element.connectors) return null;
        const newData = {...formData}
        element.connectors.forEach(c => {
            // convert to connection structure
            if (c.rules) {
                newData.paths.push({pathName: c.value_text, pathWeight: c.rules[0].weight || 0})
            } else {
                newData.paths.push({pathName: "", pathWeight: 0})
            }
        })
        setFormData(newData)
    }, [element]);

    function submit() {
        const newElement = {...element}
        if (!formData.paths) formData.paths = [];
        if (!newElement.connectors) newElement.connectors = []
        newElement.connectors = formData.paths.map((p, i) => {
            const conn = newElement.connectors.find(c => c.ordinal_position === i + 1)
            if (!conn) {
                return {
                    key: [i, element.element_hash].join('-'),
                    ordinal_position: i + 1,
                    value_text: p.pathName,
                    rules: [{weight: p.pathWeight}]
                    // check_prior_voter_selection
                    // allow_selection_of_prior_selected_voter
                }
            } else {
                if (!conn.rules) conn.rules = []
                conn['value_text'] = p.pathName;
                if (Array.isArray(conn['rules'])) {
                    const rule = conn.rules.find(r => typeof r.weight !== 'undefined')
                    rule.weight = p.pathWeight;
                } else {
                    conn['rules'] = [{weight: p.pathWeight}]
                }
            }
            return conn
        })
        console.log("RANDOMIZER SUBMITTING ", newElement)
        onSubmit(newElement);
    }

    const handleChange = (field, value) => {
        const newForm = {...formData};
        const val = value === 'true' || value == true || value === 1 || value === '1' ? true : false
        if (field === 'check_prior_voter_selection' && val === false) {
            newForm.attribs.allow_selection_of_prior_selected_voter = false;
        }
        newForm.attribs[field] = val;
        setFormData(newForm);
    };

    const handlePathChange = (index, field, value) => {
        const updatedPaths = [...formData.paths];
        updatedPaths[index][field] = value;
        setFormData({...formData, paths: updatedPaths});
    };

    const addPath = () => {
        setFormData({
            ...formData,
            paths: [...formData.paths, {pathName: "", pathWeight: ""}],
        });
    };

    const removePath = (index) => {
        const updatedPaths = formData.paths.filter((_, i) => i !== index);
        setFormData({...formData, paths: updatedPaths});
    };

    return (
        <div className="sidebar-form">
            <h6 className={'m-0 pb-2'}>
                <i className="fa fa-random mr-3"></i>
                Add a Voter Lookup with Routing by Household
            </h6>

            <div className={'mb-4'}>
                <div className={'fieldWrapper'}>
                    <label>Name</label>
                    <input
                        className={'mb-4'}
                        type="text"
                        value={formData.display_name}
                        onChange={(e) => setFormData({...formData, display_name: e.target.value})}
                    />
                </div>
                <div className={'fieldWrapper'}>
                    <label>Check for Prior Selection</label>
                    <select
                        className={"mb-1"}
                        name={'check_prior_voter_selection'}
                        value={formData.attribs?.check_prior_voter_selection}
                        onChange={(e) => handleChange("check_prior_voter_selection", e.target.value)}
                    >
                        <option value={'true'}>Check if Selected</option>
                        <option value={'false'}>Don't bother</option>
                    </select>
                </div>
                <div className={'fieldWrapper'}>
                    <label>Allow Duplicates</label>
                    <select
                        className={"mb-1"}
                        name={'allow_selection_of_prior_selected_voter'}
                        disabled={formData.attribs?.check_prior_voter_selection !== true}
                        value={formData.attribs?.allow_selection_of_prior_selected_voter}
                        onChange={(e) => handleChange("allow_selection_of_prior_selected_voter", e.target.value)}
                    >
                        <option value={'true'}>Notify canvasser of prior selection</option>
                        <option value={'false'}>Do not allow any prior selection</option>
                    </select>
                </div>
            </div>

            <fieldset>
                {formData.paths.map((path, index) => (
                    <div key={index} className="fieldWrapper">
                        <div className={'m-0 full-width flx space_between'}>
                            <label>Path {index + 1}</label>
                            {formData.paths.length > 1 && (
                                <i className="danger-text fas fa-minus-circle is-clickable mr-1"
                                   onClick={() => removePath(index)}>
                                </i>
                            )}
                        </div>

                        <input
                            type="text"
                            placeholder="Path Name"
                            className={'mb-1'}
                            value={path.pathName}
                            onChange={(e) => handlePathChange(index, "pathName", e.target.value)}
                        />
                        <input
                            type="number"
                            placeholder="Weight (%)"
                            value={path.pathWeight}
                            onChange={(e) => handlePathChange(index, "pathWeight", e.target.value)}
                        />
                    </div>
                ))}
            </fieldset>

            <button className="button button-clear m-0 pl-0" onClick={addPath}>Add Path ➕</button>

            <div className={'button-wrapper'} style={{marginTop: 10}}>
                <button onClick={submit} className={'button'}>Submit</button>
                <button onClick={onCancel} className={'button button-outline'}>Cancel</button>
                <button onClick={onDeleteElement} className={'button danger'}>Delete</button>
            </div>

        </div>
    )
        ;
};

export default VoterRoutedForm;
